// extracted by mini-css-extract-plugin
export default {"container":"style_container__cXesA","img":"style_img__C9nuE","circle":"style_circle__ffNfs","name":"style_name__2YCtw","email":"style_email__NSXrq"};